import Cookies from 'js-cookie'
import enc from "@/utils/enc"
// 加密
const aesEnc = function (val) {
  return decodeURIComponent(enc.AESEncrypt(val))
}
// 解密
const aesDec = function (val) {
  return enc.AESDecrypt(decodeURIComponent(val))
}

const TokenInfo = 'WOS-TOKENINFO'
const UserInfo = 'WOS-USERINFO'
const userMenu = 'WOS-USERMENU'
const tokenExpire = 'WOS-TOKENEXPIRE'
const getLocalInfo = function (key) {
  const _info = localStorage.getItem(key);
  const infoStr = !_info ? null : JSON.parse(aesDec(_info))
  return infoStr;
}
const getCookieInfo = function (key) {
  const _info = Cookies.get(key)
  const infoStr = !_info ? null : JSON.parse(aesDec(_info))
  return infoStr;
}
const getLocalInfoStr = function (key) {
  const _info = localStorage.getItem(key);
  const infoStr = !_info ? null : aesDec(_info)
  return infoStr;
}
const getCookieInfoStr = function (key) {
  const _info = Cookies.get(key)
  const infoStr = !_info ? null : aesDec(_info)
  return infoStr;
}

//Token 信息
export function getTokenInfo() {
  return getCookieInfo(TokenInfo)
}
export function setTokenInfo(tokenInfo) {
  return Cookies.set(TokenInfo, aesEnc(tokenInfo), { expires: (86400 - JSON.parse(tokenInfo).expire_time) / 86400 })
}
export function removeTokenInfo() {
  return Cookies.remove(TokenInfo)
}
// 用户信息
export function getUserInfo() {
  return getLocalInfo(UserInfo)
}
export function setUserInfo(info) {
  return localStorage.setItem(UserInfo, aesEnc(info))
}
export function removeUserInfo() {
  return localStorage.removeItem(UserInfo)
}
// 用户菜单
export function getMenu() {
  return getLocalInfo(userMenu)
}
export function setMenu(info) {
  return localStorage.setItem(userMenu, aesEnc(info))
}
export function removeMenu() {
  return localStorage.removeItem(userMenu)
}
//用户操作权限
export function getExpire() {
  return localStorage.getItem(tokenExpire)
}
export function setExpire(expire) {
  return localStorage.setItem(tokenExpire, expire)
}
export function removeExpire() {
  return localStorage.removeItem(tokenExpire)
}



// WEBPACK FOOTER //
// ./src/modules/web/utils/auth.js